'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var eventSplitter = /\s+/;
function Events() {
}
Events.prototype.on = function (t, e, r) {
    var n, s, i, o;
    if (!e)
        return this;
    for (n = this.__events || (this.__events = {}), t = t.split(eventSplitter); s = t.shift();)
        s = (o = s.split(':'))[0], i = o[1] || '', (n[s] || (n[s] = [])).push(e, r, i);
    return this;
}, Events.prototype.once = function (e, r, t) {
    var n = this;
    this.on(e, function t() {
        n.off(e, t), r.apply(this, arguments);
    }, t);
}, Events.prototype.off = function (t, e, r) {
    var n, s, i, o, f, l;
    if (!(n = this.__events))
        return this;
    if (!(t || e || r))
        return delete this.__events, this;
    for (t = t ? t.split(eventSplitter) : keys(n); s = t.shift();)
        if (f = (l = s.split(':'))[1] || '', i = n[s = l[0]])
            if (e || r || '' !== f)
                for (o = i.length - 3; 0 <= o; o -= 3)
                    e && i[o] !== e || r && i[o + 1] !== r || '' !== f && i[o + 2] !== f || i.splice(o, 3);
            else
                delete n[s];
    return this;
}, Events.prototype.trigger = function (t) {
    var e, r, n, s, i, o, f = [], l = !0;
    if (!(e = this.__events))
        return this;
    for (t = t.split(eventSplitter), i = 1, o = arguments.length; i < o; i++)
        f[i - 1] = arguments[i];
    for (; r = t.shift();)
        (n = e.all) && (n = n.slice()), (s = e[r]) && (s = s.slice()), l = triggerEvents(s, f, this) && l, l = triggerEvents(n, [r].concat(f), this) && l;
    return l;
}, Events.prototype.emit = Events.prototype.trigger, Events.mixTo = function (t) {
    t = isFunction(t) ? t.prototype : t;
    var e = Events.prototype;
    for (var r in e)
        e.hasOwnProperty(r) && (t[r] = e[r]);
};
var keys = Object.keys;
function triggerEvents(t, e, r) {
    var n = !0;
    if (t) {
        var s = 0, i = t.length, o = e[0], f = e[1], l = e[2];
        switch (e.length) {
        case 0:
            for (; s < i; s += 3)
                n = !1 !== t[s].call(t[s + 1] || r) && n;
            break;
        case 1:
            for (; s < i; s += 3)
                n = !1 !== t[s].call(t[s + 1] || r, o) && n;
            break;
        case 2:
            for (; s < i; s += 3)
                n = !1 !== t[s].call(t[s + 1] || r, o, f) && n;
            break;
        case 3:
            for (; s < i; s += 3)
                n = !1 !== t[s].call(t[s + 1] || r, o, f, l) && n;
            break;
        default:
            for (; s < i; s += 3)
                n = !1 !== t[s].apply(t[s + 1] || r, e) && n;
        }
    }
    return n;
}
function isFunction(t) {
    return '[object Function]' === Object.prototype.toString.call(t);
}
keys || (keys = function (t) {
    var e = [];
    for (var r in t)
        t.hasOwnProperty(r) && e.push(r);
    return e;
});
var _default = Events;
exports.default = _default;